import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';

import { TextLinkCaret } from '@vds/buttons';
import { Title, Body } from '@vds/typography';
import { Line } from '@vds/lines';
import { Row, Col, Grid } from '@vds/grids';

import { labels } from './Constants';
import NavHeader, { RenderAddress } from '../../../Common/NavHeader/NavHeader';
import * as SiteAnalytics from '../../../sitecatalyst';
import './OutofFranchise.css';
 
const OutofFranchise = (props) => {
    console.log(props);
    const { street,State,zipCode,city,unit } = props;
    const [endInteraction, setEndInteraction] = useState(false);

    useEffect(() => {
        setEndInteraction(true);
    }, [])
    useEffect(() => {
        if(endInteraction && navigator?.userAgentData?.platform !== "macOS") {
            window.newrelic.interaction().end();
            setEndInteraction(false);
        }
    });
    var Address=`${street}, ${city}, ${State}`;console.log(unit);
    SiteAnalytics.trackPageInfo("OutOfFranchise");
    window.scrollTo(0, 0);
    window.enableProactiveChat && window.enableProactiveChat();
    return (
        <>
            {!isMobileOnly && (Address !== 'None' && zipCode) && <div className={`sticky-wrapper sticky'`} >
                <NavHeader
                    customizeOrder={[]}
                    selectedServiceVoice={null}
                    globalscope={{ Address,zipCode:zipCode,unit }}
                    history={props.history}
                    hideCart
                    hidePrice
                />
            </div>}
            {isMobileOnly && (Address !== 'None' && zipCode)  && <RenderAddress globalScope={{Address,zipCode:zipCode,unit}} />}
            <Grid className="OutofFranchise" colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }} colGutter={false}>
                <Row className="Page-Content">
                    <Col className="Title-section" colSizes={{ "mobile": 4, "tablet": 9, "desktop": 9 }}>
                        <div className="Main-Title">
                            <Title size="large" primitive="h2">
                                {labels.OUT_OF_FRANCHISE_TITLE}<br />{labels.OUT_OF_FRANCHISE_TITLE1}
                            </Title>
                        </div>
                    </Col>
                </Row>
                <Row className="Page-Content">
                    <Col className="card" colSizes={{ "mobile": 4, "tablet": 3, "desktop": 3 }}>
                        <div className="card-header">
                            <div className="sm-title">
                                <Title size="large" primitive="h2">{labels.SMALL_BUSINESS_CONTENT}</Title>
                            </div>
                            <Line type="light"  />
                        </div>
                        <div className="card-body Small-Business">
                            <div className="sm-content">
                                <Body size="large" primitive="h2">{labels.SMALL_BUSINESS_CONTENT1}</Body>
                            </div>
                            <div className="oof-btn">
                                <TextLinkCaret target="_blank" href={labels.REGISTER_LINK}>
                                    Register
                            </TextLinkCaret>
                            </div>
                        </div>
                    </Col>
                    <Col className="card1" colSizes={{ "mobile": 4, "tablet": 3, "desktop": 3 }}>
                        <div className="card-header">
                            <div className="sm-title">
                                <Title size="large" primitive="h2">{labels.SMALL_BUSINESS_CONTENT3}</Title>
                            </div>
                            <Line type="light"  />
                        </div>
                        <div className="card-body Small-Business">
                            <div className="sm-content">
                                <Body size="large" primitive="h2">
                                    {labels.SMALL_BUSINESS_CONTENT2}
                                </Body>
                            </div>
                            <div className="oof-btn">
                                <TextLinkCaret target="_blank" href="https://www.verizonwireless.com/business/">
                                    Shop plans
                                </TextLinkCaret>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Grid >
        </>);
}

const mapStateToProps = (state, ownProps) => {
    /* move toggleLoadingSpinner to common reducer */
    const { AddressValidationPage } = state;
    console.log(state, ownProps);
    return {
        street: AddressValidationPage?.selectedStreetAddress?.street || 'None',
        zipCode: AddressValidationPage?.selectedZipcode?.zip || '',
        State: AddressValidationPage?.selectedZipcode?.state || '',
        city: AddressValidationPage?.selectedZipcode?.city || '',
        unit:AddressValidationPage?.selectedUnit?.unit || '',
    };
};
const mapDispatchToProps = (dispatch) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(OutofFranchise)